import { useRouter } from "next/router";
import { useEffect } from "react";

export default function useItemViewMetric(itemId: string | undefined) {
  const router = useRouter();
  useEffect(() => {
    if (itemId) {
      fetch("/api/metric", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          type: "page-view",
          data: {
            _id: itemId,
            path: router.asPath
          }
        })
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemId]);
}
